import calculateScore from '../util/calculateScore'
import getDateForPuzzleNumber from '../util/getDateForPuzzleNumber'
import { DAILY5_START_DATE } from '../config'
import { archivePuzzleCount, getArchiveResultsByPuzzleNumber } from '../controllers/archive'

export function getNextUnattemptedArchivePuzzleNumber() {
	const available = archivePuzzleCount()

	const puzzles = Array.from({ length: available }, (v, i) => {
		const existingResult = getArchiveResultsByPuzzleNumber()[i + 1]
		return {
			puzzleNumber: i + 1,
			puzzleDate: getDateForPuzzleNumber(i + 1, DAILY5_START_DATE),
			score: existingResult ? calculateScore(existingResult.time) : 0,
			time: existingResult ? existingResult.time : undefined,
		}
	})

	const nextUnattemptedPuzzle = puzzles.find(puzzle => puzzle.score === 0)

	// If they've attempted all puzzles, pick a random puzzle
	return nextUnattemptedPuzzle?.puzzleNumber ?? Math.floor(Math.random() * available)
}
